import { Commit } from 'vuex';
import StoreUtil from '@store/StoreUtil';
import { SidebarId } from './enums';
import { isSubNavigationVisible } from '@src/app/layout';

export interface IUIMobileState {
    currentlyOpenSidebar: SidebarId | null;
}

const SET_OPEN_SIDEBAR = 'SET_OPEN_SIDEBAR';

export default {
    namespaced: true,
    state: {
        currentlyOpenSidebar: null,
    } as IUIMobileState,
    mutations: {
        [SET_OPEN_SIDEBAR]: StoreUtil.createSimpleMutator('currentlyOpenSidebar'),
    },
    actions: {
        toggleSidebar({ state, commit }: { state: IUIMobileState, commit: Commit }, sidebarId: SidebarId) {
            commit('SET_OPEN_SIDEBAR', state.currentlyOpenSidebar === sidebarId
            ? null
            : sidebarId);
        },
        closeSidebar({ commit } : { commit: Commit }) {
            commit(SET_OPEN_SIDEBAR, null);
        },
    },
    getters: {
        isSidebarOpen(state: IUIMobileState) {
            return (sidebarId: SidebarId) => isSubNavigationVisible() && sidebarId === state.currentlyOpenSidebar;
        },
        // do not use directly except in app.vue
        openSidebarId: StoreUtil.createSimpleGetter('currentlyOpenSidebar'),
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/mobile/mobileIndex.ts